import React from 'react'
import './SafFound.css'
import img from './photos/sld11.jpg'
import { Fade } from "react-awesome-reveal";



function SafFound() {
    return (
        <>
            <div className="foodi1_box">

                <div className="imgbx">
                    <Fade direction="left" triggerOnce={false}>
                    <img src={img} />
                    </Fade>
                </div>

                <div className="foodi_cardContent">
                    <Fade direction="right" triggerOnce={false} >
                    <h1 className='img_head'>"Sanat Art Foundation" -S.A.F"</h1>


                    <p>Established a first professional contemporary Art gallery cum Art residency in Himachal at village Hiun, near Chadwick Fall Shimla,-<br /><a href = 'https://safweb.org/' style={{  textDecoration: 'none'}}><span style={{ fontWeight: 'bold', color: '#79c6f7ff'}}>Sanat Art Foundation-SAF</span></a></p>
                    </Fade>

                </div>

            </div>
        </>
    )
}

export default SafFound;
